import { Above18Img, AnjouanLicenseImg } from '@repo/icons';
import { Tooltip } from '@repo/ui/tooltip';
import { useTranslations } from 'next-intl';
import React from 'react';
import { UnStyledLink } from '@/components/common/link';
import { useTenant } from '@/providers/TenantProvider';

const LicenseItems = () => {
  const { tenantMachineName } = useTenant();
  const t = useTranslations('footer');

  return (
    <div className="flex w-full flex-col items-center space-y-3 py-10 sm:flex-row sm:space-x-3 sm:space-y-0 rtl:space-x-reverse">
      <UnStyledLink
        href="/static/responsible-gambling"
        className="flex h-[60px] w-full items-center space-x-2 rounded px-3 vt-surface-light-bg sm:w-[290px] rtl:space-x-reverse"
      >
        <Above18Img />
        <span className="font-semibold vt-font-highlight-font-family vt-text-size-big vt-headings-text">
          {t('play-responsible-title')}
        </span>
      </UnStyledLink>
      {tenantMachineName === 'vatan-game' && (
        <Tooltip
          asChild
          side="bottom"
          delayDuration={0}
          className="px-2 py-3"
          content={t('anjouan-license-content')}
        >
          <div className="flex h-[60px] w-full items-center space-x-2 rounded px-3 vt-surface-light-bg sm:w-[290px] rtl:space-x-reverse">
            <AnjouanLicenseImg />
            <span className="font-semibold vt-font-highlight-font-family vt-text-size-big vt-headings-text">
              {t('anjouan-license-title')}
            </span>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default LicenseItems;
